import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { FiExternalLink } from "react-icons/fi";
import toast from "react-hot-toast";
import { IoMdDocument } from "react-icons/io";
import { MdDeleteForever } from "react-icons/md";
import api from "../../../services/api";
import SelectMonth from "../../../components/selectMonth";
import { useSelector } from "react-redux";
import useStore from "../../../services/store";
import SelectVAT from "../../../components/SelectVAT";
import { User } from "./admin";
import SelectProject from "../../../components/selectProject";

const PaymentView = ({ payment, setPayment }) => {
  const [paymentUser, setpaymentUser] = useState(null);
  const organisation = useStore((state) => state.organisation);
  const user = useSelector((state) => state.Auth.user);
  const TAXES = {
    "Le Collectif": { value: 0.2, name: "FR 20%" },
    "Selego BV": { value: 0.21, name: "NL 21%" },
    "Selegoloco": { value: 0.2, name: "ES 20%" },
  };

  const ORG_COUNTRY = {
    FR: "Le Collectif",
    NL: "Selego BV",
    ES: "Selegoloco",
  };

  const [values, setValues] = useState({ ...payment });
  const [selectedTax, setSelectedTax] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPaymentUser();
    if (payment.amount) return;
  }, []);

  async function fetchPaymentUser() {
    const { data: u, ok } = await api.get(`/user/${payment.user_id}`);
    if (!ok) return toast.error("Error!\nPlease try again", { icon: "❌" });
    setpaymentUser(u);

    const orgToCountry = {
      "Le Collectif": "FR",
      "Selego BV": "NL",
      "Selegoloco": "ES",
    };

    const shouldApplyTax = u?.company_country === orgToCountry[u?.organisation_name];
    const tempSelectedTax = shouldApplyTax ? TAXES?.[u?.organisation_name] : { value: 0, name: "N/A (Not applicable)" };
    const tempSelectedTaxValue = tempSelectedTax?.value || 0;
    setSelectedTax(tempSelectedTax?.name);
    setValues({ ...values, organisation_name: u?.organisation_name, taxValue: tempSelectedTaxValue });
  }
  async function onSave() {
    try {
      const { ok, data, code } = await api.put(`/payment/${payment._id}`, { ...values });
      if (!ok) return toast.error(`Error !\n${code}`, { icon: "❌" });
      toast.success("Saved !");
      setPayment(data);
    } catch (e) {
      console.log(e);
      toast.error("Some Error!", e.code);
    }
  }

  async function onRequest() {
    try {
      if (!values.files || values.files.length === 0) return toast.error("Error!\nPlease upload an invoice", { icon: "❌" });
      const { ok, code } = await api.put(`/payment/${payment._id}`, { ...values, status: "TOPAY" });
      if (!ok) return toast.error(`Error !\n${code}`, { icon: "❌" });
      toast.success("Saved !");
    } catch (e) {
      console.log(e);
      toast.error("Some Error!", e.code);
    }
  }

  async function onDelete() {
    const confirm = window.confirm("Are you sure ?");
    if (!confirm) return;
    await api.remove(`/payment/${payment._id}`);
    toast.success("successfully removed!");
    navigate("/payment");
  }

  return (
    <div>
      <div className="p-2">
        <div className="flex gap-4">
          <span className="flex items-center text-[18px] font-semibold text-[#212325]">{`${payment.user_name}`}</span>
        </div>
        <React.Fragment>
          <div className="mt-3 flex flex-wrap gap-6">
            <div className="w-full sm:w-auto">
              <span className="text-[14px] font-medium text-[#212325]">Month</span>
              <div className="mt-2">
                <SelectMonth placeholder="Select month" indexDefaultValue={0} value={values.date} onChange={(e) => setValues({ ...values, date: e.target.value })} name="date" />
              </div>
            </div>
            <div className="w-full sm:w-auto">
              <span className="text-[14px] font-medium text-[#212325]">Organisation</span>
              <div className="mt-2">
                <select
                  disabled
                  className="input bg-gray-100 text-gray-500"
                  name="organisation_name"
                  value={values.organisation_name || ""}
                  title="User's organisation">
                  <option value="">No organisation selected</option>
                  {Object.entries(ORG_COUNTRY).map(([key, value]) => (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {payment.type === 'expense' && (
              <div className="w-full sm:w-auto">
                <span className="text-[14px] font-medium text-[#212325]">Project</span>
                <div className="mt-2">
                  <SelectProject
                    name="project"
                    value={values.project_id}
                    onChange={(project) => {
                      setValues({ ...values, project_id: project._id, project_name: project.name });
                    }}
                    filters={{
                      status: "active",
                    }}
                  />
                </div>
              </div>
            )}
            <div className="w-full sm:w-auto">
              <div className="flex gap-1 items-center">
                <span className="text-[14px] min-w-max font-medium text-[#212325]">Amount in euro (€) (HT)</span>
                <a className="flex gap-1 text-[#0560FD] text-xs font-medium ml-2" href="https://www.xe.com/currencyconverter/convert" target="_blank" rel="noreferrer">
                  Currency Converter <FiExternalLink />
                </a>
              </div>
              <input
                required
                className="border border-[#E5EAEF] rounded-[10px] w-full h-[40px] px-2 mt-2 text-[1rem] focus:outline-none focus:ring focus:ring-[#80bdff]"
                name="value"
                placeholder="€"
                type="number"
                value={values.value}
                onChange={(e) => {
                  setValues({ ...values, value: e.target.value });
                }}
              />
            </div>
            <div className="w-full sm:w-auto">
              <span className="text-[14px] font-medium text-[#212325]">VAT</span>
              <div className="mt-2">
                <div className="w-44">
                  <SelectVAT user={paymentUser} values={values} divisions={ORG_COUNTRY} selectedTax={selectedTax} />
                </div>
              </div>
            </div>

            <div className="w-full sm:w-auto">
              <span className="text-[14px] font-medium text-[#212325]">VAT Amount (€)</span>
              <div className="mt-2">
                <div className="w-44">
                  <input
                    disabled
                    required
                    className="border border-[#E5EAEF] rounded-[10px] w-full h-[40px] px-2 mt-2 text-[1rem] focus:outline-none focus:ring focus:ring-[#80bdff] bg-gray-100 text-gray-500"
                    name="value"
                    placeholder="€"
                    type="number"
                    value={Number(values.value) * Number(values.taxValue) || 0}
                  />
                </div>
              </div>
            </div>

            <div className="w-full sm:w-auto">
              <span className="text-[14px] font-medium text-[#212325]">TTC Amount (€) </span>
              <div className="mt-2">
                <div className="w-44">
                  <input
                    disabled
                    required
                    className="border border-[#E5EAEF] rounded-[10px] w-full h-[40px] px-2 mt-2 text-[1rem] focus:outline-none focus:ring focus:ring-[#80bdff] bg-gray-100 text-gray-500"
                    name="value"
                    placeholder="€"
                    type="number"
                    value={Number(values.value) + Number(values.value) * Number(values.taxValue) || 0}
                  />
                </div>
              </div>
            </div>

            <div className="w-full md:w-[265px]">
              <UploadInvoice name="files" value={values.files} onChange={(e) => setValues({ ...values, files: e.target.value })} />
            </div>
          </div>
          <div className="mt-4 flex flex-col xl:flex-row justify-around items-center">
            <Activities payment={payment} />
            <User user={paymentUser} payment={payment} />
          </div>
          <div className="w-full mt-4">
            <span className="text-[14px] font-medium text-[#212325]">Comment</span>
            <textarea
              className="w-full border border-[#E5EAEF] mt-2 rounded-[10px] text-sm pt-2 pl-2  focus:outline-none focus:ring focus:ring-[#80bdff]"
              placeholder="Please add a comment on what you in your mind...."
              rows="5"
              name="comment"
              value={values.comment}
              onChange={(e) => {
                setValues({ ...values, comment: e.target.value });
              }}
            />
          </div>
          {paymentUser?.contract === "FREELANCE" && organisation && (
            <div className="w-full mt-4">
              <span className="text-[14px] font-medium text-[#212325] flex items-center">
                <svg className="w-4 h-4 mr-2 text-[#0560FD]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
                </svg>
                Informations de l'organisation
              </span>
              <div className="mt-2 p-5 border border-[#E5EAEF] rounded-[10px] bg-gray-50 shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div className="bg-white p-3 rounded-lg border-l-4 border-[#0560FD]">
                    <p className="text-sm text-gray-600 font-medium mb-1">Nom:</p>
                    <p className="text-sm font-medium text-gray-800">{organisation.name}</p>
                  </div>
                  <div className="bg-white p-3 rounded-lg border-l-4 border-[#0560FD]">
                    <p className="text-sm text-gray-600 font-medium mb-1">Adresse:</p>
                    <p className="text-sm font-medium text-gray-800">{organisation.address}</p>
                  </div>
                  <div className="bg-white p-3 rounded-lg border-l-4 border-[#0560FD]">
                    <p className="text-sm text-gray-600 font-medium mb-1">TVA:</p>
                    <p className="text-sm font-medium text-gray-800">{organisation.vat}</p>
                  </div>
                  <div className="bg-white p-3 rounded-lg border-l-4 border-[#0560FD]">
                    <p className="text-sm text-gray-600 font-medium mb-1">IBAN:</p>
                    <p className="text-sm font-medium text-gray-800">{organisation.iban}</p>
                  </div>
                  <div className="bg-white p-3 rounded-lg border-l-4 border-[#0560FD] md:col-span-2">
                    <p className="text-sm text-gray-600 font-medium mb-1">Email:</p>
                    <p className="text-sm font-medium text-gray-800">{organisation.email}</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="mt-2">
            <button className="bg-[#0560FD] text-[16px] font-medium text-[#fff] py-[12px] px-[22px] rounded-[10px]" onClick={onSave}>
              Save Progress
            </button>
            <button className="ml-[10px] bg-[#0560FD] text-[16px] font-medium text-[#fff] py-[12px] px-[22px] rounded-[10px]" onClick={onRequest}>
              Request Payment
            </button>
            {user?.role === "admin" && (
              <button className="ml-[10px] bg-[#F43F5E] text-[16px] font-medium text-[#FFFFFF] py-[12px] px-[22px] rounded-[10px]" onClick={onDelete}>
                Delete
              </button>
            )}
          </div>
        </React.Fragment>
      </div>
    </div>
  );
};

const UploadInvoice = ({ onChange, name, value }) => {
  function readFileAsync(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  const renderFileName = (file) => {
    if (file.startsWith("https")) return `${file.substring(0, 8)}...${file.substring(file.length - 15)}`;
    return "Cached filed (send to upload)";
  };

  const onDelete = (index) => {
    const newValue = value.filter((_, i) => i !== index);
    onChange({ target: { value: newValue, name } });
  };

  return (
    <div>
      <label className="text-[14px] font-medium text-[#212325] mb-0">Invoice(s)</label>
      {(value || []).map((file, i) => (
        <div key={file} className="flex items-center mt-1">
          <a className="flex gap-1 items-center text-sm text-gray-700 hover:underline cursor-pointer" href={file} target="_blank" rel="noreferrer">
            <IoMdDocument />
            {renderFileName(file)}
          </a>
          {/* TODO */}
          <div className="flex justify-center cursor-pointer text-xl hover:text-red-500 ml-2">
            <MdDeleteForever onClick={() => onDelete(i)} />
          </div>
        </div>
      ))}
      <label htmlFor="file-upload" className="flex pl-[20px] items-center w-[172px] h-[40px] border border-[#ccc] bg-[#F9FBFD] rounded-[10px] mt-[7px] cursor-pointer">
        Upload a file
      </label>
      <input
        id="file-upload"
        className="mt-2"
        name={name}
        type="file"
        onChange={async (e) => {
          const fileBuffer = await readFileAsync(e.target.files[0]);
          const newFiles = [...(value || []), fileBuffer];
          onChange({ target: { value: newFiles, name } });
        }}
      />
    </div>
  );
};

const Activities = ({ payment }) => {
  const [activities, setActivities] = useState([]);

  if (payment.type !== "activity") return <div />;

  const { id } = useParams();

  useEffect(() => {
    (async () => {
      const { data: a } = await api.get(`/activity?userId=${payment.user_id}&date=${payment.date}&exclude_unavailable_project=true`);
      setActivities(a);
    })();
  }, [id]);

  const cost = activities.reduce((acc, cur) => acc + cur.cost, 0);
  const hours = activities.reduce((acc, cur) => acc + cur.total, 0);

  if (!activities.length) return <div>No activities</div>;

  return (
    <div className="w-2/3">
      <div className="bg-[#FFFFFF] border border-[#E5EAEF] rounded-[10px] my-3">
        <div className="p-3 border-b-2 border-[#E5EAEF]">
          <Link className="text-[18px] font-semibold text-[#212325]" to={`/activity?userId=${payment.user_id}&date=${activities[0].date}`}>
            Activities
          </Link>
        </div>
        <div className="overflow-x-auto">
          <table className="w-[700px] md:w-full table-fixed">
            <thead>
              <tr className="border-b border-[#E5EAEF] text-[14px] font-semibold text-[#212325]">
                <th className="p-3">Projects</th>
                <th>Days</th>
                <th>Cost</th>
              </tr>
            </thead>
            <tbody>
              {activities.map((e, i) => {
                return (
                  <tr key={i} className="border-b border-[#E5EAEF] text-[14px] text-[#676D7C] font-medium">
                    <td className="p-3">{e.projectName} </td>
                    <td>{(e.total / 8)?.toFixed(2)}</td>
                    <td>{`${e.cost?.toFixed(2)} €`}</td>
                  </tr>
                );
              })}
              <tr key="total" className="text-[14px] font-semibold text-[#212325]">
                <td className="p-3">Total-</td>
                <td>{`${(hours / 8)?.toFixed(2)} days`}</td>
                <td>{`${cost?.toFixed(2)} €`}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PaymentView;
